const STORAGE_KEY = 'camit-jpy-eur-rate'
const MEMORY_TTL_MS = 30 * 60 * 1000

let memory = null

function storage() {
  try {
    return globalThis.localStorage
  } catch {
    return null
  }
}

export function normalizeExchangeRate(payload) {
  const rate = Number(payload?.rate)
  if (!(rate > 0)) return null
  return {
    pair: payload.pair || 'JPY_EUR',
    rate,
    date: String(payload.date || ''),
    retrieved_at: String(payload.retrieved_at || payload.date || new Date().toISOString()),
    source: String(payload.source || 'cache'),
    stale: Boolean(payload.stale),
  }
}

export function readCachedRate(now = Date.now()) {
  if (memory?.value?.rate > 0 && now - memory.storedAt < MEMORY_TTL_MS) {
    return { ...memory.value, fresh: true }
  }
  const raw = storage()?.getItem(STORAGE_KEY)
  if (!raw) return memory?.value?.rate > 0 ? { ...memory.value, fresh: false } : null
  try {
    const parsed = normalizeExchangeRate(JSON.parse(raw))
    if (!parsed) return null
    if (!memory) memory = { storedAt: 0, value: parsed }
    else memory.value = parsed
    return { ...parsed, fresh: Boolean(memory.storedAt && now - memory.storedAt < MEMORY_TTL_MS) }
  } catch {
    return null
  }
}

export function writeCachedRate(payload) {
  const value = normalizeExchangeRate(payload)
  if (!value) return null
  memory = { storedAt: Date.now(), value }
  try {
    storage()?.setItem(STORAGE_KEY, JSON.stringify(value))
  } catch {
    // quota ou stockage indisponible
  }
  return value
}

export function clearCachedRate() {
  memory = null
  try {
    storage()?.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}

export function expireCachedRate() {
  if (memory?.value) memory.storedAt = 0
}

export function convertObservedJpy(observed, rate) {
  const amount = Number(observed)
  const value = Number(rate)
  if (!(amount > 0) || !(value > 0)) return null
  return Math.round(amount * value * 100) / 100
}

export async function resolveJpyEurRate(fetchLive) {
  const cached = readCachedRate()
  if (cached?.fresh && cached.rate > 0) {
    return { ...cached, source: cached.source || 'cache', stale: false }
  }
  try {
    const live = await fetchLive()
    const normalized = normalizeExchangeRate(live)
    if (normalized) {
      writeCachedRate(normalized)
      return {
        ...normalized,
        source: live.stale ? 'cache' : (normalized.source || 'live'),
        stale: Boolean(live.stale),
      }
    }
  } catch {
    if (cached?.rate > 0) return { ...cached, source: 'cache', stale: true }
    return null
  }
  if (cached?.rate > 0) return { ...cached, source: 'cache', stale: true }
  return null
}
